import CmmTitle from './CmmTitle';
import CmmSubTitle from './CmmSubTitle';
import CmmContainer from './CmmContainer';

import TotalSummary from './TotalSummary';
import TotalSummaryIconItems from './TotalSummaryIconItem';

import SalesTable from './sales/SalesTable';
import SalesTableHeader from './sales/SalesTableHeader';
import SalesTableBody from './sales/SalesTableBody';
import SalesTableRow from './sales/SalesTableRow';
import SalesTableCell from './sales/SalesTableCell';

import BoardList from './BoardList';
import BoardListItem from './BoardListItem';

import TodayTask from './TodayTask';
import DropdownMenu from './DropdownMenu';

const moneyInKorean = (amount) => {
  const units = ['', '십', '백', '천'];
  const nums = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  const man = '만';
  const uk = '억';
  const tk = '조';

  const numToKorean = (num) => {
    const result = [];

    if (num === 0) {
      return '영';
    }

    let man_count = 0;
    while (num > 0) {
      let n = num % 10000;
      let str = '';

      for (let i = 0; i < 4; i++) {
        str = (n % 10 ? nums[n % 10] + units[i] : '') + str;
        n = Math.floor(n / 10);
      }

      if (str !== '') {
        result.unshift(str + (man_count ? man.repeat(man_count) : ''));
      }

      num = Math.floor(num / 10000);
      man_count++;
    }

    return result.join(uk);
  };

  const value = numToKorean(Number(amount));

  return value;
};

const getColorWithOpacity = (color, opacity) => {
  let rgb = {};

  switch (color) {
    case 'purple':
      rgb = { r: 145, g: 85, b: 253 };
      break;
    case 'green':
      rgb = { r: 86, g: 202, b: 0 };
      break;
    case 'yellow':
      rgb = { r: 255, g: 180, b: 0 };
      break;
    case 'sky':
      rgb = { r: 22, g: 177, b: 255 };
      break;
    case 'year':
      rgb = { r: 145, g: 85, b: 253 };
      break;
    case 'quarter':
      rgb = { r: 86, g: 202, b: 0 };
      break;
    case 'month':
      rgb = { r: 255, g: 180, b: 0 };
      break;
  }

  return opacity ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.12)` : `rgba(${rgb.r}, ${rgb.g}, ${rgb.b})`;
};

export {
  CmmTitle,
  CmmSubTitle,
  CmmContainer,
  TotalSummary,
  TotalSummaryIconItems,
  SalesTable,
  SalesTableHeader,
  SalesTableBody,
  SalesTableRow,
  SalesTableCell,
  BoardList,
  BoardListItem,
  TodayTask,
  DropdownMenu,
  moneyInKorean,
  getColorWithOpacity
};
